import { scrollTo } from "../assets/js/helpers";
const ToggleMapAndCards = ({ viewsList, currentView, setCurrentView }) => {
  const handleClick = () => {
    setCurrentView((prevValue) =>
      prevValue === viewsList[0] ? viewsList[1] : viewsList[0]
    );
    scrollTo();
  };

  return (
    <div className="text-center">
      <button className="" onClick={handleClick}>
        <div className="inline-flex items-center px-3 py-3 text-white text-[15px] font-medium bg-primary-700 rounded-full border-2 border-transparent transition-all duration-300 hover:bg-white hover:text-primary-700 hover:border-primary-700">
          <span className="px-2">
            <currentView.oppositeViewIcon />
          </span>
          <span className="px-2 inline-block">
            {currentView.oppositeViewName}
          </span>
        </div>
      </button>
    </div>
  );
};

export default ToggleMapAndCards;
